import React, { useState } from 'react';
import { Row, Container, Nav, NavItem, NavLink, } from 'reactstrap';
import FilterInput from '../FilterInput';
import { SupplierDto } from '../Requests/Suppliers/useGetSuppliers';
import useDisplayMessage from '../Common/useDisplayMessage';
import KaAlert from '../Common/KaAlert';
import BoldButton from '../Common/BoldButton';
import SuppliersTab from './SuppliersTab';
import PurchaseOrdersTab, { PoModalState } from './PurchaseOrdersTab';
import { PurchaseOrderDto } from '../Requests/PurchaseOrders/useGetPurchaseOrders';
import { PurchaseOrderTransactionPage } from './Transactions/PurchaseOrderTransactionPage';

enum Views {
  ActivePOs,
  CompletedPOs,
  Suppliers,
}

const PurchaseOrderPage = () => {
  const [filterText, setFilterText] = useState('');
  const [view, setView] = useState<Views>(Views.ActivePOs);
  const [createEditSupplier, setCreateEditSupplier] = useState<{ supplier?: SupplierDto } | undefined>(undefined);
  const [modalState, setModalState] = useState<PoModalState>({ state: 'Hidden' });
  const [poTransactionsToView, setPoTransactionToView] = useState<PurchaseOrderDto | undefined>(undefined);
  const displayMessage = useDisplayMessage();

  const changeTabs = (view: Views) => {
    setFilterText('');
    displayMessage.clear();
    setCreateEditSupplier(undefined);
    setModalState({ state: 'Hidden' });
    setView(view);
  }

  return <Container>
    {
      poTransactionsToView
        ? <PurchaseOrderTransactionPage
          purchaseOrder={poTransactionsToView}
          backClicked={() => setPoTransactionToView(undefined)} />
        : <>
          <Row className="justify-content-between mb-2">
            <h2 className="col-auto ka-blue">Purchase Orders</h2>
            {
              view !== Views.Suppliers &&
              <BoldButton
                className='col-auto btn-ghost-primary'
                onClick={() => setModalState({ state: 'Create' })}>
                Create Purchase Order
              </BoldButton>
            }
            {
              view === Views.Suppliers &&
              <BoldButton
                className='col-auto btn-ghost-primary'
                onClick={() => setCreateEditSupplier({ supplier: undefined })}>
                Create Supplier
              </BoldButton>
            }
          </Row>
          <form>
            <KaAlert displayMessage={displayMessage.message} onClose={displayMessage.clear} />
            <div className="row gx-2 gx-md-3 mb-7">
              <div className="col-md-4 mb-2 mb-md-0">
                <FilterInput
                  placeholder={`Filter ${view === Views.Suppliers ? 'suppliers' : 'purchase orders'} by keyword`}
                  value={filterText}
                  onFilterTextChange={(text) => setFilterText(text)} />
              </div>
            </div>
          </form>
          <div className="d-flex justify-content-center mb-3">
            <Nav tabs className="w-75 row d-flex justify-content-center">
              <NavItem className="col px-0">
                <NavLink
                  className="d-flex justify-content-center"
                  active={view === Views.ActivePOs}
                  onClick={() => changeTabs(Views.ActivePOs)}>
                  Active
                </NavLink>
              </NavItem>
              <NavItem className="col px-0">
                <NavLink
                  className="d-flex justify-content-center"
                  active={view === Views.CompletedPOs}
                  onClick={() => changeTabs(Views.CompletedPOs)}>
                  Completed
                </NavLink>
              </NavItem>
              <NavItem className="col px-0">
                <NavLink
                  className="d-flex justify-content-center"
                  active={view === Views.Suppliers}
                  onClick={() => changeTabs(Views.Suppliers)}>
                  Suppliers
                </NavLink>
              </NavItem>
            </Nav>
          </div>
          {
            (view === Views.ActivePOs || view === Views.CompletedPOs) &&
            <PurchaseOrdersTab
              filterText={filterText}
              modalState={modalState}
              setModalState={setModalState}
              requestSuccessful={displayMessage.success}
              requestFailed={displayMessage.fail}
              setViewTransaction={setPoTransactionToView}
              completed={view === Views.CompletedPOs} />
          }
          {
            view === Views.Suppliers &&
            <SuppliersTab
              filterText={filterText}
              createEditSupplier={createEditSupplier}
              setCreateEditSupplier={setCreateEditSupplier}
              requestSuccessful={displayMessage.success}
              requestFailed={displayMessage.fail} />
          }
        </>
    }
  </Container>;
}

export default PurchaseOrderPage;
